exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jflow-restitution-box .ref_input {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.jflow-restitution-box .pop-btn {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.jflow-restitution-box .pop-btn .cancel-btn {\n  margin-left: 10px;\n}\n", ""]);

// exports
